import { render, staticRenderFns } from "./Footer4Entry.vue?vue&type=template&id=52866f50&"
import script from "./Footer4Entry.vue?vue&type=script&lang=js&"
export * from "./Footer4Entry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports